import Disclosure from "../utils/Disclosure.js";

class BurgerMenu {
    constructor(element) {
        this.el = element;

        this.subMenuEls = this.el.querySelectorAll(".menu__sub-menu");

        const disclosureObjects = window.allDisclosure;

        this.searchFormDisclosure =
            disclosureObjects["searchForm"] !== undefined
                ? disclosureObjects["searchForm"]
                : false;

        //console.log("Burger menu", window.allDialogs);
        //console.log("Burger menu", this.searchFormDisclosure);

        this.init();
    }

    init() {
        // ---------------------------------------------------------------------
        // Set up sub menu expanding/collapsing functionality using Disclosure.
        // ---------------------------------------------------------------------
        if (this.subMenuEls.length > 0) {
            this.subMenuEls.forEach((element) => {
                if (element instanceof Element) {
                    const disclosure = new Disclosure(element, {
                        // collapseOnFocusout: !this.isBurgerModeActive(),
                        animate: true,
                        collapseOnAncestorCollapse: true,
                        collapseOnOtherElementsExpand: this.subMenuEls,
                    });

                    // const dropdown = {
                    //     element,
                    //     disclosure,
                    //     parent: element.closest(".menu-item"),
                    // };

                    // // Add hover listeners to dropdown parents
                    // this.subMenuDropdowns[element.id] = dropdown;

                    // // Only add hover actions to top level submenus
                    // if (!disclosure.el.matches("[data-menu-depth='0']")) {
                    //     return;
                    // }

                    disclosure.collapse();
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const siteHeaderOverlay = document.getElementById("site-header-overlay");

    if (siteHeaderOverlay) {
        new BurgerMenu(siteHeaderOverlay);
    }
});
